// src/config/api.js
// Zentrale API-Konfiguration - Einfach zwischen lokal und Produktion wechseln

// Für lokales Testen: 'http://localhost:5000'
// Für Produktion: 'https://brainwizzr-backend-41f7251d9520.herokuapp.com'
const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://brainwizzr-backend-41f7251d9520.herokuapp.com';

export default API_BASE_URL;


